import { render } from "./homeNewsCentre.vue?vue&type=template&id=53b10c4e&scoped=true"
import script from "./homeNewsCentre.vue?vue&type=script&lang=js"
export * from "./homeNewsCentre.vue?vue&type=script&lang=js"

import "./homeNewsCentre.vue?vue&type=style&index=0&id=53b10c4e&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b10c4e"]])

export default __exports__